import React from 'react';
import { TAppRoutes } from '../../app/features/routes/types/TAppRoute';
import Faq from './Faq';
import PFaqPublic from './pages/PFaqPublic';

const FaqRoutes = {
	faq: {
		tag: 'faq',
		path: '/faq',
		auth: false,
		component: <PFaqPublic />,
	},
	faq_investor: {
		tag: 'faq_investor',
		path: '/faq/investor',
		auth: true,
		layout: 'investor',
		component: <Faq page="investor" />,
	},
} as TAppRoutes;

export default FaqRoutes;
